// extracted by mini-css-extract-plugin
export default {"productContainer":"ProductContainer_productContainer__REheO"};